<div class="form-group" ngModelGroup="{{ formField.id }}">
    @if (formField.label) {
        <label for="form-element-{{ formField.id }}" (click)="htmlDivElement.focus()">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }
    <div
        #dropzone
        [dropzone]="config"
        id="form-element-{{ formField.id }}"
        class="drop dropzone"
        [ngClass]="{ 'ng-invalid': formField.isRequired && formService.isSubmitted && !formField.value.length }"
        (success)="onUploadSuccess($event)"
        (processing)="onProcessUploading()"
        (error)="attachmentService.onFailedUploading($event)"
        (queueComplete)="onFinishUploading()"
        (removedFile)="onRemovedFile($event)">
        <div
            class="dz-message-custom dropzone-click-target"
            #htmlDivElement
            data-dz-message
            tabindex="0"
            role="button"
            (keydown)="onKeyDown($event, htmlDivElement)">
            <span class="truncate">{{ formField.placeholder }}</span>
            <sb-inline-svg
                class="icon dz-message-icon"
                [url]="'sb-tools/theme/images/download-icon.svg'"></sb-inline-svg>
        </div>
    </div>
    @if (formService.isSubmitted && !files.length && formField.isRequired) {
        <div class="text-danger" translate>At least one file should be uploaded</div>
    }
</div>
